// ------------------------------------
// Ação Múltiplos
// ------------------------------------
(function ($) {
  'use strict';

  // Configurações de cada tipo de ação
  const alertCfg = {
    // Mudança de status
    status: {
      type: 'default',
      title: 'Confirmação',
      text: 'Deseja alterar todos os itens selecionados?',
      btnConfirmText: 'Alterar',
      btnCancelText: 'Cancelar',
      successMsg: 'Itens atualizados com sucesso.',
      multiple: true,
    },
    // Remove múltiplos itens
    remove: {
      type: 'danger',
      title: 'Confirmação',
      text: 'Deseja remover todos os itens selecionados?',
      btnConfirmText: 'Remover',
      btnCancelText: 'Cancelar',
      successMsg: 'Itens removidos com sucesso.',
      multiple: true,
    },
    // Remove item único
    remove_unico: {
      type: 'danger',
      title: 'Confirmação',
      text: 'Deseja remover este item?',
      btnConfirmText: 'Remover',
      btnCancelText: 'Cancelar',
      successMsg: 'Item removido com sucesso.',
      multiple: false,
    },
    // Gerar etiquetas
    gerar_etiquetas: {
      type: 'default',
      title: 'Confirmação',
      text: 'Deseja gerar as etiquetas de todos os itens selecionados?',
      btnConfirmText: 'Gerar',
      btnCancelText: 'Cancelar',
      successMsg: 'Etiquetas geradas com sucesso.',
      multiple: true,
    },
    // Arquiva múltiplos itens
    arquiva: {
      type: 'danger',
      title: 'Confirmação',
      text: 'Deseja arquivar todos os itens selecionados?',
      btnConfirmText: 'Arquivar',
      btnCancelText: 'Cancelar',
      successMsg: 'Itens arquivados com sucesso.',
      multiple: true,
    },
    // Desarquiva múltiplos itens
    desarquiva: {
      type: 'default',
      title: 'Confirmação',
      text: 'Deseja desarquivar todos os itens selecionados?',
      btnConfirmText: 'Desarquivar',
      btnCancelText: 'Cancelar',
      successMsg: 'Itens desarquivados com sucesso.',
      multiple: true,
    },
  };

  // Tabelas gerenciáveis
  const $tablesMng = $('.table-mng');
  $tablesMng.each(function () {
    // Variáveis
    const $table = $(this);
    const $checkAll = $table.find('input.select-all');
    const $formMult = $($table.data('form-mult'));
    const $inputIDs = $formMult.find('input[name="ids"]');
    const $inputAction = $formMult.find('input[name="acao"]');
    const $inputValue = $formMult.find('input[name="valor"]');
    const $dropdownActions = $($table.data('actions'));
    const $counters = $($table.data('count'));
    let sending = false;
    let action;
    let value;

    // Altera a opção "Selecionar todos"
    $checkAll.on('change', function () {
      if ($checkAll.is(':checked')) {
        checkAll();
      } else {
        uncheckAll();
      }
      populateIDs();
      toggleActions();
    });

    // Altera a seleção de uma linha
    $table.on('change', 'input.check-row', function () {
      updateCheckAll();
      populateIDs();
      toggleActions();
    });

    // Evento de clique em uma ação 'Múltiplos'
    $dropdownActions.on('click', '[data-action]', handleAction);

    // Evento de clique no botão de remover
    $table.on('click', '[data-action]', handleAction);

    // Evento de click em uma ação
    function handleAction(ev) {
      ev.preventDefault();
      action = $(this).data('action');
      value = $(this).data('value');
      console.log({
        action,
        value,
      });
      $inputAction.val(action);
      $inputValue.val(value);
      if (alertCfg[action].multiple && $inputIDs.val() == '') {
        Toast.fire({
          type: 'warning',
          title: 'Selecione pelo menos um item da lista.',
        });
        resetForm();
        return false;
      }
      showAlertMultiple();
    }

    // Selecione todas as linhas da tabela
    function checkAll() {
      $table.find('input.check-row').prop('checked', true);
    }

    // Desseleciona todas as linhas da tabela
    function uncheckAll() {
      $table.find('input.check-row').prop('checked', false);
    }

    // Retorna a quantidade de itens selecionados
    function getTotalChecked() {
      return $table.find('input.check-row:checked').length;
    }

    // Atualiza o campo "Selecionar todos"
    function updateCheckAll() {
      if (getTotalChecked() === $table.find('input.check-row').length) {
        $checkAll.prop('checked', true);
      } else {
        $checkAll.prop('checked', false);
      }
    }

    // Popula os ID's selecionados separados por vírgula no campo oculto
    function populateIDs() {
      const ids = [];
      $table.find('input.check-row:checked').each(function () {
        ids.push($(this).val());
      });
      $inputIDs.val(ids.join(',')).parsley().validate();
    }

    // Exibe/Oculta o dropdown das ações
    function toggleActions() {
      if ($dropdownActions.length > 0) {
        if (getTotalChecked() > 0) {
          $dropdownActions.removeClass('d-none');
        } else {
          $dropdownActions.addClass('d-none');
        }
      }
    }

    // Retorna a quantidade de itens da lista
    function getTotalItens() {
      return $table.find('tr[data-row]').length;
    }

    // Atualiza o total de registros
    function updateTotalRegistros() {
      $counters.text(getTotalItens());
    }
    updateTotalRegistros();

    // Exibe o alerta de acordo com a ação selecionada
    function showAlertMultiple() {
      showConfirm({
        type: alertCfg[action]['type'],
        title: alertCfg[action]['title'],
        text: alertCfg[action]['text'],
        confirmButtonText: alertCfg[action]['btnConfirmText'],
        cancelButtonText: alertCfg[action]['btnCancelText'],
        callback: function () {
          if (!sending) {
            const url = $formMult.attr('action');
            const method = $formMult.attr('method');
            const formData = new FormData($formMult[0]);
            $.ajax({
              url: url,
              type: method,
              data: formData,
              contentType: false,
              cache: false,
              processData: false,
              beforeSend: sendingForm,
              success: successForm,
              error: errorForm,
            });
          }
        },
      });
    }

    // Ações executadas quando o form é processado com sucesso
    function successForm(resp) {
      console.log(resp);
      resetForm();
      try {
        resp = JSON.parse(resp);
        // Sucesso
        if (resp.status == 'success') {
          if (resp.acao == 'status') {
            processaStatus(resp);
          }
          if (resp.acao == 'remove_unico') {
            processaRemoveUnico(resp);
          }
          if (resp.acao == 'remove' || resp.acao == 'arquiva' || resp.acao == 'desarquiva') {
            processaRemove(resp);
          }
        }
        // Erro
        else {
          Toast.fire({
            type: 'error',
            title: resp.mensagem,
          });
        }
      } catch (error) {
        console.log(error);
        Toast.fire({
          type: 'error',
          title: 'Não foi possível realizar esta operação.',
        });
      }
    }

    // Ações executadas antes e enquanto o formulário é processado
    function sendingForm() {
      sending = true;
      showLoader();
    }

    // Ações executadas quando ocorre algum erro ao processar o form
    function errorForm(resp) {
      console.log(resp);
      resetForm();
      Toast.fire({
        type: 'error',
        title: 'Não foi possível realizar esta operação.',
      });
    }

    // Retorna o formulário ao estado inicial
    function resetForm() {
      $checkAll.prop('checked', false);
      $table.find('input.check-row').prop('checked', false);
      $inputAction.val('');
      $inputValue.val('');
      $inputIDs.val('');
      sending = false;
      toggleActions();
      hideLoader();
    }

    // Atualiza o status dos elementos da lista
    function processaStatus(resp) {
      $.each(resp.ids, function (index, idItem) {
        const $itemRow = $table.find('[data-row="' + idItem + '"]');
        const $statusEl = $itemRow.find('[data-status]');
        $statusEl.text(resp.status_texto).removeClass(resp.classes).addClass(resp.status_class);
      });
      Toast.fire({
        type: 'success',
        title: alertCfg[action]['successMsg'],
      });
    }

    // Remove um item da lista
    function removeItem(item) {
      $(document).trigger('remove', [$table[0]]);
      const $itemRow = $table.find('[data-row="' + item + '"]');
      $itemRow.remove();
      updateTotalRegistros();
      if (getTotalItens() === 0) {
        setTimeout(() => {
          location.reload();
        }, 1500);
      }
    }

    // Processa a ação de remover um item único
    function processaRemoveUnico(resp) {
      $(document).trigger('remove_unico');
      removeItem(resp.id);
      Toast.fire({
        type: 'success',
        title: alertCfg[action]['successMsg'],
      });
    }

    // Processa a ação de remover múltiplos itens
    function processaRemove(resp) {
      $.each(resp.ids, function (index, idItem) {
        removeItem(idItem);
      });
      Toast.fire({
        type: 'success',
        title: alertCfg[action]['successMsg'],
      });
    }
  });
})(jQuery);
